import React from 'react';
import { Card } from './ui/Card';
import { XCircle, Lock, Repeat } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const problems = [{
    icon: XCircle,
    title: '"Dile que pare" falla',
    description: 'La bioquímica adictiva es más fuerte que su voluntad. Pedirle que pare es como pedirle a un adicto que deje la droga con la botella en la mano.'
  }, {
    icon: Lock,
    title: 'Apps de control fallan',
    description: 'Sin un sistema familiar sólido, el niño encuentra la forma de hackear o burlar los controles parentales. La tecnología sola no educa.'
  }, {
    icon: Repeat,
    title: '"Solo un rato más" empeora todo',
    description: 'Cada minuto extra multiplica la resistencia. El ciclo de dopamina se fortalece y la explosión emocional al apagar es inevitable.'
  }];
  return <section className="py-20 bg-brand-light" data-id="element-150">
      <div className="container mx-auto px-4" data-id="element-151">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-6" data-id="element-153">
            ¿Por qué nada de lo que has intentado funciona?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-154">
            No es tu culpa. Estás luchando contra ingenieros de Silicon Valley
            diseñando algoritmos para secuestrar la atención de tu hijo. Las
            estrategias tradicionales ya no sirven.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-155">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} data-id="element-156">
              <Card className="h-full p-8 border-t-4 border-t-brand-accent hover:shadow-xl transition-shadow bg-white" data-id="element-157">
                <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-158">
                  <problem.icon className="w-7 h-7 text-brand-accent" data-id="element-159" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4 text-center" data-id="element-160">
                  {problem.title}
                </h3>
                <p className="text-slate-600 text-center leading-relaxed" data-id="element-161">
                  {problem.description}
                </p>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}